var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Outlet } from 'react-router-dom';
import { CssBaseline, Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { CloseDrawerWidth, DrawerWidth } from "../../constants";
import { setIsLeftMenuOpen, setSafeAreaMargin } from "../../redux/commonSlice";
import { MuiBox } from "../atoms/boxComponent";
import { Header } from "./header";
import { Sidebar } from "./sidebar";
import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { SafeArea } from 'capacitor-plugin-safe-area';
export var Layout = function (props) {
    var dispatch = useDispatch();
    var commonState = useSelector(function (state) { return state.common; });
    var safeAreaMargin = useSelector(function (state) {
        var _state$common;
        return (_state$common = state.common) === null || _state$common === void 0 ? void 0 : _state$common.safeAreaMargin;
    });
    useEffect(function () {
        var fetchSafeAreaInsets = function () { return __awaiter(void 0, void 0, void 0, function () {
            var insets;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android')) return [3 /*break*/, 2];
                        return [4 /*yield*/, SafeArea.getSafeAreaInsets()];
                    case 1:
                        insets = (_a.sent()).insets;
                        dispatch(setSafeAreaMargin({
                            top: insets.top,
                            bottom: insets.bottom,
                            left: insets.left,
                            right: insets.right
                        }));
                        _a.label = 2;
                    case 2:
                        ;
                        return [2 /*return*/];
                }
            });
        }); };
        fetchSafeAreaInsets();
    }, []);
    return /*#__PURE__*/ React.createElement(Stack, {
        height: "100svh"
    }, /*#__PURE__*/ React.createElement(CssBaseline, null), /*#__PURE__*/ React.createElement(Header, {
        mobileOpen: commonState.isMenuOpen,
        handleMobileOpen: function () { return dispatch(setIsLeftMenuOpen(!commonState.isMenuOpen)); },
        desktopOpen: commonState.isMenuOpen,
        handleDesktopOpen: function (value) {
            dispatch(setIsLeftMenuOpen(!commonState.isMenuOpen));
        },
        safeAreaMargin: safeAreaMargin
    }), /*#__PURE__*/ React.createElement(Sidebar, {
        mobileOpen: commonState.isMenuOpen,
        handleMobileOpen: function () { return dispatch(setIsLeftMenuOpen(!commonState.isMenuOpen)); },
        desktopOpen: commonState.isMenuOpen,
        handleDesktopOpen: function (value) {
            dispatch(setIsLeftMenuOpen(!commonState.isMenuOpen));
        }
    }), /*#__PURE__*/ React.createElement(MuiBox, {
        component: "main",
        sx: {
            flexGrow: 1,
            marginLeft: {
                md: "".concat(commonState.isMenuOpen ? DrawerWidth : CloseDrawerWidth, "px"),
                lg: "".concat(commonState.isMenuOpen ? DrawerWidth : CloseDrawerWidth, "px")
            },
            // height: `calc(100vh - ${HeaderWidth}px)`,
            width: "calc(100vw -".concat(commonState.isMenuOpen ? DrawerWidth : 5, "px)"),
            pt: "".concat(safeAreaMargin !== null && safeAreaMargin !== void 0 && safeAreaMargin.top && (safeAreaMargin === null || safeAreaMargin === void 0 ? void 0 : safeAreaMargin.top) > 0 ? safeAreaMargin.top + 'px' : '68px')
        }
    }, /*#__PURE__*/ React.createElement(Outlet, null)));
};
